<div class="bg-light min-vh-100 d-flex flex-row align-items-center">
  <c-container>
    <c-row class="justify-content-center">
      <c-col md="6">
        <c-card-group>
          <c-card class="p-4">
            <c-card-body>
              <form cForm [formGroup]="form" (submit)="onSubmit()">
                <div class="row">
                  <div class="col-7">
                    <h1>Entrar</h1>
                    <p class="text-muted">Acesse sua conta</p>
                  </div>
                  <div class="col-5" style="text-align-last: end;">
                    <img src="assets/img/brand/logo-ladder.png" style="height: 70px" alt="Logo" />
                  </div>
                </div>
                <c-input-group class="mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilUser"></svg>
                  </span>
                  <input autoComplete="username" cFormControl placeholder="Usuário" formControlName="username"
                    required />
                </c-input-group>
                <c-input-group class="mb-4">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input autoComplete="current-password" cFormControl placeholder="Senha"
                    [type]="showPwd ? 'text' : 'password'"
                    formControlName="password" required/>
                  <span class="click" cInputGroupText (click)="showPwd = !showPwd">
                    <svg cIcon name="cilLowVision"></svg>
                  </span>
                </c-input-group>

                <div class="alert alert-danger mb-3" *ngIf="!!error">
                  {{ error }}
                </div>

                <c-row>
                  <c-col xs="6">
                    <button cButton class="px-4" color="primary" type="submit" [disabled]="form.invalid">
                      Entrar
                    </button>
                  </c-col>
                  <c-col class="text-right" xs="6" style="text-align-last: end;">
                    <button cButton class="px-0" color="link" (click)="forgotPassword()">
                      Esqueceu a senha?
                    </button>
                  </c-col>
                </c-row>
              </form>
            </c-card-body>
          </c-card>
          <!-- <c-card [ngStyle]="{'width.%': 44}" class="text-white bg-primary py-5">
            <c-card-body class="text-center">
              <div>
                <h2>Não tem acesso?</h2>
                <p>
                  Entre em contato com a revenda de sua região e solicite uma demonstração.
                </p>
                <button [active]="true" cButton class="mt-3" color="primary" routerLink="/register">
                  Entre em contato!
                </button>
              </div>
            </c-card-body>
          </c-card> -->
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>
